import { axiosGet } from "../../Helpers";

export const loadJobs = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("job/listjob");
  setLoading(false);
  const data = response.data?.data;
  data.map((item, index) => {
    item.id = index + 1;
  });
  return data;
};
export const loadEmpLocations = async (setLoading, employeeId) => {
  setLoading(true);
  const response = await axiosGet("empLocation/listEmpLocation/" + employeeId);
  setLoading(false);
  const data = response.data?.data;
  data.map((item, index) => {
    item.id = index + 1;
  });
  return data;
};
